import Vue from 'vue';

import { get } from '../../request';

const state = () => ({
    privacy: null,
    terms: null,
    faq: null,
});

const getters = {
};

const mutations = {
    error(s, e) {
      Vue.set(s, 'error', e);
    },
    setTerms(s, terms) {
      Vue.set(s, 'terms', terms);
    },
    setPrivacy(s, privacy) {
      Vue.set(s, 'privacy', privacy);
    },
    setFAQ(s, faq) {
      Vue.set(s, 'faq', faq);
    },
};

const actions = {
  async doGetPrivacy({ commit }) {
    commit('error', null);
    try {
      const data = await get('/conf/privacy/MERCHANT/latest', { commit });
      commit('setPrivacy', data.label);
    } catch (e) {
      commit('error', e);
    }
  },
  async doGetTerms({ commit }) {
    commit('error', null);
    try {
      const data = await get('/conf/terms/MERCHANT/latest', { commit });
      commit('setTerms', data.label);
    } catch (e) {
      commit('error', e);
    }
  },

  async doGetFAQ({ commit }, faqType) {
    commit('error', null);
    try {
      const data = await get(`/faqs/by_type/${faqType}`, { commit });
      commit('setFAQ', data);
    } catch (e) {
      commit('error', e);
    }
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
